import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Banner from "../components/Banner";
import Loading from "../components/Loading";
import banner from "../assets/banner.jpg";
import "../scss/prestation-details.scss";

import { getServices } from "../utils/API";

const PrestationDetails = () => {
  const { id, prestation } = useParams();

  const [loading, setLoading] = useState(true);
  const [prestationData, setPrestationData] = useState({});

  useEffect(() => {
    const fetchService = async () => {
      try {
        const res = await getServices();
        const service = res.data.filter(el => el._id === id);
        setPrestationData(service[0]);
        setLoading(false);
      } catch (error) {
        console.error("Un problème est survenu lors de la lecture des données !");
      }
    };
    fetchService();
    document.title = `Formule ${prestation.toLowerCase()}`;
  }, [id, prestation]);

  return (
    <div style={{ width: "100%" }}>
      <div className="banner">
        <Banner img={banner} />
        <h1>{prestationData.label}</h1>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="details">
          <div className="description-wrapper">
            <div className="description">
              <p>{prestationData.description}</p>
            </div>
            <div className="examples">
              {prestationData.examples.map((example, index) => (
                <img key={index} src={`${process.env.REACT_APP_API_URI}/${example.src}`} alt={example} />
              ))}
            </div>
          </div>

          <div className="templates">
            {prestationData.templates.map((template, index) => (
              <img key={index} src={`${process.env.REACT_APP_API_URI}/${template.src}`} alt={template.name} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PrestationDetails;
